import { Link } from 'react-router-dom';
import MetaHead from '../components/MetaHead';
import QualitySafetyBox from '../components/QualitySafetyBox';

export default function AboutPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12">
      <MetaHead 
        title="Om - Din Privat Psykolog"
        description="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogTitle="Om Marie Aagaard Larsen - Din Privat Psykolog"
        ogDescription="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/61a0bb4f-47a8-4ecb-a747-8c6184fb1879_3bd59b5a.jpg"
      />

      {/* Header */}
      <div className="border-b border-[#E0D7C6] pb-8 space-y-3">
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Om Marie Aagaard Larsen
        </h1>
        <p className="text-base sm:text-lg text-[#3B4D42] max-w-3xl leading-relaxed">
          Klinisk psykolog cand. psych. aut. med over 20 års erfaring inden for behandlingsområdet, krisehjælp og supervision.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        
        {/* Main Content */}
        <div className="lg:col-span-8 space-y-10 text-[#4A5D50] leading-relaxed text-sm sm:text-base">
          
          {/* Fagligt fundament og etik - Ren editorial introstil */}
          <div className="pb-8 border-b border-[#EAE3D5]">
            <span className="text-[11px] font-semibold tracking-[0.2em] text-[#C6A868] uppercase block mb-3">
              Fagligt fundament og etik
            </span>
            <p className="font-serif text-lg sm:text-xl text-[#2C3B32] leading-relaxed">
              Jeg er autoriseret klinisk psykolog og har over 20 års bred klinisk erfaring. Jeg arbejder efter gældende fagetiske principper og er desuden underlagt Psykologloven. Min fulde titel er: Klinisk psykolog cand. psych. aut.
            </p>
          </div>

          {/* Terapeutisk tilgang og det hele menneske */}
          <div className="space-y-4">
            <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#5f7365]">
              Terapeutisk tilgang og det hele menneske
            </h2>
            <p>
              Jeg gør brug af forskellige terapeutiske metoder og tilrettelægger og tilpasser altid metode, form og indhold efter hver enkelt klients specifikke situation, behov og ressourcer.
            </p>
            <p>
              Jeg arbejder med det hele menneske, og derfor kommer vi rundt om hele dig allerede i den indledende samtale: Dine følelser, tanker og kropslige oplevelser.
            </p>
          </div>

          {/* Erfaring og målgrupper */}
          <div className="space-y-4">
            <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#5f7365]">
              Erfaring og målgrupper
            </h2>
            <p>
              Undervejs i min psykologkarriere har jeg beskæftiget mig med mennesker med mange forskellige baggrunde, forudsætninger, udfordringer, symptomer, reaktioner og diagnoser.
            </p>
            <p>
              Jeg har opsamlet erfaring igennem en række fuldtids og deltidsansættelser, ved siden af mit selvstændige virke. (<Link to="/cv" className="text-[#5f7365] font-semibold underline underline-offset-4 hover:text-[#2C3B32] transition-colors">Se mit CV her</Link>)
            </p>
            <p>
              <strong className="font-medium text-[#2C3B32]">Særlig kriseerfaring:</strong> Jeg har udover mere almindelige psykologiske problemstillinger desuden også en særlig ekspertise og erfaring i forhold til behandling af akutte storkriser (f.eks. Fields skyderiet), vold, voldtægter, ulykker og dødsfald.
            </p>
          </div>

          {/* Metoder og faglig kvalitet */}
          <div className="space-y-4">
            <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#5f7365]">
              Metoder og faglig kvalitet
            </h2>
            <p>
              Jeg har flere terapeutiske efteruddannelser, blandt andet indenfor mentaliseringsbaseret terapi og den evidensbaserede metode: EMDR. Og jeg er bredt inspireret af de nyeste retninger inden for kognitiv og metakognitiv terapi, hvor jeg også har taget specialistgodkendt kursus i ACT.
            </p>
            <p>
              Herudover kan jeg ved behov for at arbejde mere konkret, supplere samtaleterapi med elementer fra tegneterapeutisk metode, som jeg også har taget flere kurser i.
            </p>
            <p>
              Jeg modtager desuden løbende både supervision og egenterapi, for at sikre en høj kvalitet i mit arbejde samt forebygge udbrændthed og omsorgstræthed.
            </p>
          </div>

          {/* To rolige, balancerede paneler: Mere om mig & Terapikortet */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-2">
            <div className="bg-white border border-[#5f7365] p-6 sm:p-7 flex flex-col justify-between">
              <div>
                <span className="text-[10px] font-semibold tracking-[0.18em] text-[#C6A868] uppercase block mb-2">
                  Mennesket bag psykologen
                </span>
                <h3 className="font-serif text-xl text-[#2C3B32] mb-3">
                  Mere om mig
                </h3>
                <p className="text-xs sm:text-sm text-[#4A5D50] leading-relaxed">
                  Ved siden af mit arbejde som privatpsykolog, er jeg ledelsescoach, amatørarkæolog, opdagelsesrejsende, familie menneske, livsnyder, kreativ og forfatter. Jeg har selv gennemlevet og overlevet min portion kriser og er ved intensiv egenterapi, kommet godt og hel igennem. Så jeg kender bestemt godt at sidde på den anden side af terapibordet også. Jeg ved at det holder mig menneskelig og ydmyg i kontakten med mine klienter.
                </p>
              </div>
            </div>

            <div className="bg-white border border-[#5f7365] p-6 sm:p-7 flex flex-col justify-between">
              <div>
                <span className="text-[10px] font-semibold tracking-[0.18em] text-[#C6A868] uppercase block mb-2">
                  Struktur og overblik
                </span>
                <h3 className="font-serif text-xl text-[#2C3B32] mb-3">
                  Terapikortet og terapimappen
                </h3>
                <p className="text-xs sm:text-sm text-[#4A5D50] leading-relaxed">
                  Er konkrete redskaber jeg har udviklet, hvori vi kan kortlægge dine symptomer, formålet med terapien samt opskrive mål og behandlingspunkter. Dette for at, du hurtigt får et overblik, og vi får et fælles, konkret sprog for de ellers så "usynlige" psykiske processer, der arbejdes med i terapi. Og så du kan holde snuden i sporet imellem sessionerne.
                </p>
              </div>
            </div>
          </div>

          {/* Kontakt mig - Rent moderne banner */}
          <div className="bg-[#5f7365] text-white p-7 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 shadow-xs">
            <div className="space-y-1.5 max-w-xl">
              <h3 className="font-serif text-xl sm:text-2xl text-white">
                Kontakt mig
              </h3>
              <p className="text-xs sm:text-sm text-white/90 leading-relaxed">
                Kontakt mig ved spørgsmål. Jeg er her for at hjælpe dig hver skridt på vejen. Og jeg tror på, at der er et bedre liv til alle.
              </p>
            </div>
            <Link
              to="/kontakt"
              className="shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-white text-[#2C3B32] font-semibold text-xs hover:bg-[#FAF8F5] transition-all hover:-translate-y-0.5"
            >
              <i className="fa-regular fa-envelope" />
              Send en besked til Marie
            </Link>
          </div>

          {/* Kvalitet, sikkerhed og ansvar - Samme bredde som ovenstående indhold */}
          <QualitySafetyBox />

        </div>

        {/* Sidebar Info */}
        <div className="lg:col-span-4 space-y-6">
          {/* Portrait of Marie */}
          <div className="overflow-hidden border border-[#EDE6D8] shadow-sm">
            <img
              src="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/61a0bb4f-47a8-4ecb-a747-8c6184fb1879_3bd59b5a.jpg"
              alt="Marie Aagaard Larsen - Autoriseret Klinisk Psykolog"
              className="w-full h-auto"
            />
            <div className="p-3 bg-[#FAF8F5] border-t border-[#EDE6D8]">
              <p className="font-serif font-bold text-sm text-[#5f7365]">Marie Aagaard Larsen</p>
              <p className="text-xs text-[#52685B]">Klinisk psykolog cand. psych. aut.</p>
            </div>
          </div>

          <div className="space-y-4">
            <div className="space-y-1">
              <h2 className="font-serif font-bold text-lg text-[#5f7365]">
                Faglige titler og certifikater
              </h2>
              <p className="text-xs text-[#52685B]">
                Godkendt og under tilsyn af offentlige myndigheder
              </p>
            </div>

            <ul className="space-y-2 text-xs text-[#5f7365] pt-2">
              <li className="flex items-start gap-2">
                <i className="fa-regular fa-check text-emerald-700 mt-0.5" />
                <span>Autoriseret af Psykolognævnet (2011)</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-regular fa-check text-emerald-700 mt-0.5" />
                <span>Titel: Klinisk Psykolog (2026-ordning)</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-regular fa-check text-emerald-700 mt-0.5" />
                <span>Tilsyn af Styrelsen for Patientsikkerhed</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-regular fa-check text-emerald-700 mt-0.5" />
                <span>Candidata Psychologiae (cand. psych. aut.) KU 2005</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="fa-regular fa-check text-emerald-700 mt-0.5" />
                <span>Grunduddannelse i filosofi, KU 2000</span>
              </li>
            </ul>

            <div className="pt-4 border-t border-[#E5DFD1]">
              <Link
                to="/cv"
                className="w-full py-2.5 px-4 bg-[#F8F5EE] hover:bg-white border border-[#D5CEBF] hover:border-[#5f7365] text-[#5f7365] font-semibold rounded-none text-xs flex items-center justify-center gap-2 transition-all duration-200 hover:-translate-y-1 shadow-2xs"
              >
                <i className="fa-regular fa-file-lines" />
                Læs det fulde CV
              </Link>
            </div>
          </div>

          {/* Clinic atmosphere photo in sidebar */}
          <div className="overflow-hidden border border-[#EDE6D8]">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/5aea2071-4f6b-4f4c-b231-1dfc61e8cfe8.jpg"
              alt="Marie Aagaard Larsen i privatklinikken"
              className="w-full h-48 object-cover object-top"
            />
            <p className="p-2.5 text-[11px] text-[#5A7364] bg-[#FAF8F5]">I privatklinikken i Gram</p>
          </div>

          <div className="pt-6 border-t border-[#EDE6D8] space-y-3">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Erhvervspsykolog og HumanEye
            </h2>
            <p className="text-xs text-[#384A3F] leading-relaxed">
              Marie tilbyder også erhvervspsykologiske ydelser, ledelsescoaching og medarbejderudvikling gennem HumanEye.
            </p>
            <a
              href="http://www.humaneye.dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs font-semibold text-[#5f7365] hover:underline transition-colors"
            >
              <span>Besøg humaneye.dk (Erhvervspsykolog)</span>
              <i className="fa-regular fa-arrow-up-right-from-square text-[10px]" />
            </a>
          </div>

          <div className="pt-6 border-t border-[#EDE6D8] space-y-3">
            <h2 className="font-serif font-bold text-lg text-[#5f7365]">
              Lokale sponsorater
            </h2>
            <p className="text-xs text-[#384A3F] leading-relaxed">
              Klinikken støtter gode sager og tiltag i lokalområdet. I 2026 og 2027 er Marie medsponsor for projektet <em>Start et hjerte, red et liv</em>.
            </p>
            <Link
              to="/klinikken"
              className="inline-flex items-center gap-2 text-xs font-semibold text-[#5f7365] hover:underline transition-colors"
            >
              <span>Læs mere på kliniksiden</span>
              <i className="fa-regular fa-arrow-right text-[10px]" />
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}
